import React from 'react'
import { CommandBar } from '@fluentui/react/lib/CommandBar';

function ToolBar(props) {

    //Parametros de entrada.
    const inputParam_ToolbarItems = props.items !== null && props.items !== undefined ? props.items : undefined;
    const inputParam_OverflowItems = props.overflowItems !== null && props.overflowItems !== undefined ? props.overflowItems : undefined;
    const inputParam_Display = props.display;
    const inputParam_Styles = props.styles !== null && props.styles !== undefined ? props.styles : {};
    

    //Parametros posibles a obtener como parametros de entrada.


    //Parametros de componente.


    //Funciones de componente.


    //Eventos de componente.


    //Render de componente.
    return (
        <>
            {
                inputParam_Display &&
                <CommandBar items={inputParam_ToolbarItems ? inputParam_ToolbarItems : undefined} overflowItems={inputParam_OverflowItems ? inputParam_OverflowItems : undefined} styles={inputParam_Styles} /> 
            }
            
        </>
    );
}

export default ToolBar;